export default "__VITE_ASSET__BSvKZR8e__"